// extracted by mini-css-extract-plugin
export default {"logo":"future_Atvp82fukoQY","header":"future_Ug_WY9mpbpUI"};